import { bannerActionsType } from '../../constants';

export function banners(state = {}, action) {
    switch (action.type) {
        case bannerActionsType.LIST_BANNERS:
            return {
                ...state,
                banners: action.banners
            };
        case bannerActionsType.GET_BANNER:
            return {
                ...state,
                banner: action.banner
            };
        default:
            return state
    }
}